import moment from 'moment';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Flex } from 'reflexbox';

import * as graphql from '@treams/treams-network';
import { Container, Jumbo, Spinner, Table, tokens } from '@treams/treams-ui';

import { IntegrationsTabs } from '../Connectors';

export default function SSOFailedAttempts() {
	const { t } = useTranslation();

	const { data, loading } = graphql.useFailedSsoAttemptsQuery({
		variables: {
			last: 100,
		},
	});

	const [attempts, setAttempts] = useState<graphql.FailedSsoAttempt[]>([]);

	useEffect(() => {
		if (data?.failedSsoAttempts) {
			setAttempts(data.failedSsoAttempts.edges.map(({ node }) => node).reverse());
		}
	}, [data?.failedSsoAttempts]);

	return (
		<>
			<Jumbo
				title={t('settings.integrations.sso.failedAttempts.title')}
				description={t('settings.integrations.sso.failedAttempts.description')}
				footer={<IntegrationsTabs />}
			/>
			<Container pt={`${tokens.gap.page}px`} pb={4}>
				{loading && (
					<Flex my={4} justifyContent="center">
						<Spinner />
					</Flex>
				)}

				{!loading && attempts && (
					<Table>
						<Table.Header>
							<Table.Cell basis={1}>
								{t('common.settings.failedSsoAttempts.columns.occurredAt')}
							</Table.Cell>
							<Table.Cell basis={3}>
								{t('common.settings.failedSsoAttempts.columns.externalID')}
							</Table.Cell>
						</Table.Header>
						{attempts.map((row) => (
							<Table.Row key={row.id}>
								<Table.Cell basis={1}>
									{moment(row.occurredAt).format('YYYY-MM-DD HH:mm:ss')}
								</Table.Cell>
								<Table.Cell basis={3}>{row.externalID}</Table.Cell>
							</Table.Row>
						))}
					</Table>
				)}
			</Container>
		</>
	);
}
